import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import PaymentPlans from 'components/settings/PaymentPlans';
import PaymentCurrentSubscription from 'components/settings/PaymentCurrentSubscription';
import PaymentEventsTable from 'components/settings/PaymentEventsTable';

import { fetchPaymentPlans } from 'redux/modules/paymentPlans';
import { fetchPaymentEvents } from 'redux/modules/paymentEvents';
import { fetchBusiness } from 'redux/modules/business';
import { addRouterParamsPageSettings } from 'redux/modules/routerParams';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.business['Company Subscription Payment']
        && props.business['Company Subscription Payment']['Last Finished Payment']
        && props.business['Company Subscription Payment']['Last Finished Payment'].Status
        && props.business['Company Subscription Payment']['Last Finished Payment'].Status === 'payed'
        ? false : true,
    };

    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.onPaymentRequest = this.onPaymentRequest.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchPaymentPlans({
      triggerLoading: true,
    });
    actions.fetchBusiness({
      triggerLoading: true,
    });
    this.onPaymentRequest();
  }

  componentWillReceiveProps(nextProps) {
    const { business } = this.props;
    if (!business.ID && nextProps.business.ID) {   
      this.setState({
        edit: nextProps.business['Company Subscription Payment']
          && nextProps.business['Company Subscription Payment']['Last Finished Payment']
          && nextProps.business['Company Subscription Payment']['Last Finished Payment'].Status
          && nextProps.business['Company Subscription Payment']['Last Finished Payment'].Status === 'payed'
          ? false : true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { limit, offset } = this.props;
    const limitChanged = prevProps.limit !== limit;
    const offsetChanged = prevProps.offset !== offset;

    if (limitChanged || offsetChanged) {
      this.onPaymentRequest();
    }
  }

  onPaymentRequest() {
    const { actions, limit, offset } = this.props;
    actions.fetchPaymentEvents({
      limit,
      offset,
      triggerLoading: true,
    });
  }

  onChangePage(event, page) {
    const { actions, location } = this.props;
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        offset: page * this.props.limit,
      },
    });
  }

  onChangeRowsPerPage(event) {
    const { actions, location } = this.props;
    window.scrollTo(0, 0);
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        limit: event.target.value,
        offset: 0,
      },
    });
  }

  onEditButtonClick() {
    this.setState({ edit: true });
  }

  render() {
    const { paymentPlans, business, paymentEvents, history, loading, limit, offset, paymentEventsCount } = this.props;
    const { edit } = this.state;
    const freePlan = paymentPlans ? paymentPlans.find(item => item['Is Fake']) : null;
    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Payment Dashboard
          </title>
        </Helmet>
        {loading > 0 ? (
          <Progress />
        ) : (
          <Fragment>
            {edit ? (
              <PaymentPlans
                paymentPlans={paymentPlans}
                business={business}
                onSelect={(values) => {
                  history.push({
                    pathname: '/settings/payment/business',
                    state: {
                      'Price ID': values['Price ID'],
                      'Unit Amount': values['Unit Amount'],
                    },
                  });
                }}
              />
            ) : (
              <Fragment>
                <PaymentCurrentSubscription
                  paymentPlans={paymentPlans}
                  business={business}
                  onEditButtonClick={this.onEditButtonClick}
                />
                <PaymentEventsTable
                  items={paymentEvents}
                  page={offset / limit}
                  rowsPerPage={limit}
                  count={paymentEventsCount}
                  onChangePage={this.onChangePage}
                  onChangeRowsPerPage={this.onChangeRowsPerPage}
                  loading={loading}
                />
              </Fragment>
            )}
          </Fragment>
        )}
      </Layout>
    );
  }
}

Payment.propTypes = {
  paymentEvents: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  paymentFormValues: PropTypes.shape({
    'Payment Plan ID': PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchPaymentPlans: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
};

Payment.defaultProps = {
  paymentFormValues: {},
  limit: 10,
  offset: 0,
};

const mapStateToProps = (store, ownProps) => ({
  paymentPlans: store.paymentPlans.data,
  business: store.business.data,
  paymentEvents: store.paymentEvents.data,
  paymentEventsCount: store.paymentEvents.count,
  loading: store.paymentPlans.loading + store.business.loading + store.paymentEvents.loading,
  ...store.routerParams.pageSettings[ownProps.location.pathname],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPaymentPlans,
    fetchPaymentEvents,
    fetchBusiness,
    addRouterParamsPageSettings,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);



// WEBPACK FOOTER //
// ./src/pages/settings/Payment.js